import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  class: "chat-page"
};
const _hoisted_2 = {
  class: "media-page"
};
const _hoisted_3 = {
  class: "search-box"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 0,
  class: "chat-title-input"
};
const _hoisted_7 = {
  key: 1,
  class: "chat-title"
};
const _hoisted_8 = {
  class: "chat-opt"
};
const _hoisted_9 = {
  class: "tool-box"
};
const _hoisted_10 = {
  class: "chat-container"
};
const _hoisted_11 = {
  class: "chat-config"
};
const _hoisted_12 = {
  class: "role-option"
};
const _hoisted_13 = {
  class: "flex-center"
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  class: "input-box"
};
const _hoisted_16 = {
  class: "input-box-inner"
};
const _hoisted_17 = {
  class: "input-body"
};
const _hoisted_18 = {
  class: "input-border"
};
const _hoisted_19 = {
  class: "input-inner"
};
const _hoisted_20 = {
  key: 0,
  class: "file-list"
};
const _hoisted_21 = ["rows"];
const _hoisted_22 = {
  class: "flex-between"
};
const _hoisted_23 = {
  class: "flex little-btns"
};
const _hoisted_24 = {
  class: "tool-item-btn"
};
const _hoisted_25 = {
  class: "flex little-btns"
};
const _hoisted_26 = {
  class: "send-btn tool-item-btn"
};
const _hoisted_27 = {
  class: "notice p-4"
};
const _hoisted_28 = ["innerHTML"];
const _hoisted_29 = {
  class: "dialog-footer"
};
const _hoisted_30 = ["src"];
import { nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import ChatPrompt from "@/components/ChatPrompt.vue";
import ChatReply from "@/components/ChatReply.vue";
import { Delete, Edit, InfoFilled, More, Plus, Promotion, Search, Share, VideoPause } from "@element-plus/icons-vue";
import "highlight.js/styles/a11y-dark.css";
import { isMobile, randString, removeArrayItem, UUID } from "@/utils/libs";
import { ElMessage, ElMessageBox } from "element-plus";
import { httpGet, httpPost } from "@/utils/http";
import { useRouter } from "vue-router";
import Clipboard from "clipboard";
import { checkSession, getClientId, getSystemInfo } from "@/store/cache";
import Welcome from "@/components/Welcome.vue";
import { useSharedStore } from "@/store/sharedata";
import FileSelect from "@/components/FileSelect.vue";
import FileList from "@/components/FileList.vue";
import ChatSetting from "@/components/ChatSetting.vue";
import BackTop from "@/components/BackTop.vue";
import { closeLoading, showLoading, showMessageError } from "@/utils/dialog";
import MarkdownIt from "markdown-it";
import emoji from "markdown-it-emoji";
export default {
  __name: 'ChatPlus',
  setup(__props) {
    const title = ref("ZHIPAIAI-智能助手");
    const models = ref([]);
    const modelID = ref(0);
    const chatData = ref([]);
    const allChats = ref([]); // 会话列表
    const chatList = ref(allChats.value);
    const mainWinHeight = ref(0); // 主窗口高度
    const chatBoxHeight = ref(0); // 聊天内容框高度
    const leftBoxHeight = ref(0);
    const loading = ref(false);
    const loginUser = ref(null);
    const roles = ref([]);
    const router = useRouter();
    const roleId = ref(0);
    const chatId = ref();
    const newChatItem = ref(null);
    const isLogin = ref(false);
    const showHello = ref(true);
    const inputRef = ref(null);
    const textHeightRef = ref(null);
    const showNotice = ref(false);
    const notice = ref("");
    const noticeKey = ref("SYSTEM_NOTICE");
    const store = useSharedStore();
    const row = ref(1);
    const showChatSetting = ref(false);
    const listStyle = ref(store.chatListStyle);
    const config = ref({
      advance_voice_power: 0
    });
    const voiceChatUrl = ref("");
    watch(() => store.chatListStyle, newValue => {
      listStyle.value = newValue;
    });
    const tools = ref([]);
    const toolSelected = ref([]);
    const stream = ref(store.chatStream);
    watch(() => store.chatStream, newValue => {
      stream.value = newValue;
    });
    if (isMobile()) {
      router.push("/mobile/chat");
    }

    // 初始化角色ID参数
    if (router.currentRoute.value.query.role_id) {
      roleId.value = parseInt(router.currentRoute.value.query.role_id);
    }

    // 初始化 ChatID
    chatId.value = router.currentRoute.value.params.id;
    if (!chatId.value) {
      chatId.value = UUID();
    } else {
      // 查询对话信息
      httpGet("/chat/detail", {
        chat_id: chatId.value
      }).then(res => {
        roleId.value = res.data.role_id;
        modelID.value = res.data.model_id;
      }).catch(e => {
        console.error("获取对话信息失败：" + e.message);
      });
    }

    // 获取系统配置
    getSystemInfo().then(res => {
      config.value = res.data;
      title.value = config.value.title;
    }).catch(e => {
      ElMessage.error("获取系统配置失败：" + e.message);
    });
    const md = new MarkdownIt({
      breaks: true,
      html: true,
      linkify: true,
      typographer: true
    }).use(emoji);
    // 获取系统公告
    httpGet("/config/get?key=notice").then(res => {
      try {
        notice.value = md.render(res.data["content"]);
        const oldNotice = localStorage.getItem(noticeKey.value);
        // 如果公告有更新，则显示公告
        if (oldNotice !== notice.value && notice.value.length > 10) {
          showNotice.value = true;
        }
      } catch (e) {
        console.warn(e);
      }
    }).catch(e => {
      ElMessage.error("获取系统配置失败：" + e.message);
    });

    // 获取工具函数
    httpGet("/function/list").then(res => {
      tools.value = res.data;
    }).catch(e => {
      showMessageError("获取工具函数失败：" + e.message);
    });

    // 创建 socket 连接
    const prompt = ref("");
    const showStopGenerate = ref(false); // 停止生成
    const lineBuffer = ref(""); // 输出缓冲行
    const canSend = ref(true);
    const isNewMsg = ref(true);
    onMounted(() => {
      resizeElement();
      initData();
      const clipboard = new Clipboard(".copy-reply, .copy-code-btn");
      clipboard.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.on("error", () => {
        ElMessage.error("复制失败！");
      });
      window.onresize = () => resizeElement();
      store.addMessageHandler("chat", data => {
        // 丢去非本频道和本客户端的消息
        if (data.channel !== "chat" || data.clientId !== getClientId()) {
          return;
        }
        if (data.type === "error") {
          ElMessage.error(data.body);
          return;
        }
        const chatRole = getRoleById(roleId.value);
        if (isNewMsg.value && data.type !== "end") {
          const prePrompt = chatData.value[chatData.value.length - 1]?.content;
          chatData.value.push({
            type: "reply",
            id: randString(32),
            icon: chatRole["icon"],
            prompt: prePrompt,
            content: data.body
          });
          isNewMsg.value = false;
          lineBuffer.value = data.body;
        } else if (data.type === "end") {
          // 消息接收完毕
          // 追加当前会话到会话列表
          if (newChatItem.value !== null) {
            newChatItem.value["title"] = tmpChatTitle.value;
            newChatItem.value["chat_id"] = chatId.value;
            chatList.value.unshift(newChatItem.value);
            newChatItem.value = null; // 只追加一次
          }
          enableInput();
          lineBuffer.value = ""; // 清空缓冲

          // 获取 token
          const reply = chatData.value[chatData.value.length - 1];
          httpPost("/chat/tokens", {
            text: "",
            model: getModelValue(modelID.value),
            chat_id: chatId.value
          }).then(res => {
            reply["created_at"] = new Date().getTime();
            reply["tokens"] = res.data;
            // 将聊天框的滚动条滑动到最底部
            nextTick(() => {
              document.getElementById("chat-box").scrollTo(0, document.getElementById("chat-box").scrollHeight);
            });
          }).catch(() => {});
          isNewMsg.value = true;
        } else if (data.type === "text") {
          lineBuffer.value += data.body;
          const reply = chatData.value[chatData.value.length - 1];
          if (reply) {
            reply["content"] = lineBuffer.value;
          }
        }
        // 将聊天框的滚动条滑动到最底部
        nextTick(() => {
          document.getElementById("chat-box").scrollTo(0, document.getElementById("chat-box").scrollHeight);
          localStorage.setItem("chat_id", chatId.value);
        });
      });
    });
    onUnmounted(() => {
      store.removeMessageHandler("chat");
    });
    // 初始化数据
    const initData = () => {
      // 加载模型
      httpGet("/model/list").then(res => {
        models.value = res.data;
        if (!modelID.value) {
          modelID.value = models.value[0].id;
        }
        // 加载角色列表
        httpGet(`/api/app/list/user`, {
          id: roleId.value
        }).then(res => {
          roles.value = res.data;
          if (!roleId.value) {
            roleId.value = roles.value[0]["id"];
          }

          // 如果登录状态就创建对话连接
          checkSession().then(user => {
            loginUser.value = user;
            isLogin.value = true;
            newChat();
          }).catch(() => {});
        }).catch(e => {
          ElMessage.error("获取聊天角色失败: " + e.messages);
        });
      }).catch(e => {
        ElMessage.error("加载模型失败: " + e.message);
      });

      // 获取会话列表
      httpGet("/chat/list").then(res => {
        if (res.data) {
          chatList.value = res.data;
          allChats.value = res.data;
        }
      }).catch(() => {
        ElMessage.error("加载会话列表失败！");
      });

      // 允许在输入框粘贴文件
      inputRef.value.addEventListener("paste", event => {
        const items = (event.clipboardData || window.clipboardData).items;
        for (let item of items) {
          if (item.kind === "file") {
            const file = item.getAsFile();
            const formData = new FormData();
            formData.append("file", file);
            loading.value = true;
            // 执行上传操作
            httpPost("/upload", formData).then(res => {
              files.value.push(res.data);
              ElMessage.success({
                message: "上传成功",
                duration: 500
              });
              loading.value = false;
            }).catch(e => {
              ElMessage.error("文件上传失败:" + e.message);
              loading.value = false;
            });
            break;
          }
        }
      });
    };
    const getRoleById = function (rid) {
      for (let i = 0; i < roles.value.length; i++) {
        if (roles.value[i]["id"] === rid) {
          return roles.value[i];
        }
      }
      return null;
    };
    const resizeElement = function () {
      chatBoxHeight.value = window.innerHeight - 101 - 82 - 38;
      // chatBoxHeight.value = window.innerHeight;

      // mainWinHeight.value = window.innerHeight - 101;
      mainWinHeight.value = window.innerHeight - 59;

      // mainWinHeight.value = window.innerHeight;

      // leftBoxHeight.value = window.innerHeight - 90 - 45 - 82;
      // leftBoxHeight.value = window.innerHeight - 90 - 82;
      leftBoxHeight.value = window.innerHeight - 90 - 100;
    };
    const _newChat = () => {
      if (isLogin.value) {
        chatId.value = UUID();
        newChat();
      }
    };
    const disableModel = ref(false);
    // 新建会话
    const newChat = () => {
      if (!isLogin.value) {
        store.setShowLoginDialog(true);
        return;
      }
      const role = getRoleById(roleId.value);
      showHello.value = role.key === "gpt";
      // if the role bind a model, disable model change
      disableModel.value = false;
      if (role.model_id > 0) {
        modelID.value = role.model_id;
        disableModel.value = true;
      }
      // 已有新开的会话
      if (newChatItem.value !== null && newChatItem.value["role_id"] === roles.value[0]["role_id"]) {
        return;
      }

      // 获取当前聊天角色图标
      let icon = "";
      roles.value.forEach(item => {
        if (item["id"] === roleId.value) {
          icon = item["icon"];
        }
      });
      newChatItem.value = {
        chat_id: "",
        icon: icon,
        role_id: roleId.value,
        model_id: modelID.value,
        title: "",
        edit: false,
        removing: false
      };
      showStopGenerate.value = false;
      loadChatHistory(chatId.value);
      router.push(`/chat/${chatId.value}`);
    };

    // 切换会话
    const loadChat = function (chat) {
      if (!isLogin.value) {
        store.setShowLoginDialog(true);
        return;
      }
      if (chatId.value === chat.chat_id) {
        return;
      }
      newChatItem.value = null;
      roleId.value = chat.role_id;
      modelID.value = chat.model_id;
      chatId.value = chat.chat_id;
      showStopGenerate.value = false;
      loadChatHistory(chatId.value);
      router.replace(`/chat/${chatId.value}`);
    };

    // 编辑会话标题
    const tmpChatTitle = ref("");
    const editChatTitle = chat => {
      chat.edit = true;
      tmpChatTitle.value = chat.title;
      nextTick(() => {
        document.getElementById("chat-" + chat.chat_id).focus();
      });
    };
    const titleKeydown = (e, chat) => {
      if (e.keyCode === 13) {
        e.stopPropagation();
        editConfirm(chat);
      }
    };
    const stopPropagation = e => {
      e.stopPropagation();
    };
    // 确认修改
    const editConfirm = function (chat) {
      if (tmpChatTitle.value === "") {
        return ElMessage.error("请输入会话标题！");
      }
      if (!chat.chat_id) {
        return ElMessage.error("对话 ID 为空，请刷新页面再试！");
      }
      if (tmpChatTitle.value === chat.title) {
        chat.edit = false;
        return;
      }
      httpPost("/chat/update", {
        chat_id: chat.chat_id,
        title: tmpChatTitle.value
      }).then(() => {
        chat.title = tmpChatTitle.value;
        chat.edit = false;
      }).catch(e => {
        ElMessage.error("操作失败：" + e.message);
      });
    };
    // 删除会话
    const removeChat = function (chat) {
      ElMessageBox.confirm(`该操作会删除"${chat.title}"`, "删除聊天", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        httpGet("/chat/remove?chat_id=" + chat.chat_id).then(() => {
          chatList.value = removeArrayItem(chatList.value, chat, function (e1, e2) {
            return e1.id === e2.id;
          });
          // 重置会话
          _newChat();
        }).catch(e => {
          ElMessage.error("操作失败：" + e.message);
        });
      }).catch(() => {});
    };
    const disableInput = force => {
      canSend.value = false;
      showStopGenerate.value = !force;
    };
    const enableInput = () => {
      canSend.value = true;
      showStopGenerate.value = false;
    };
    const onInput = e => {
      // 根据输入的内容自动计算输入框的行数
      const lineHeight = parseFloat(window.getComputedStyle(inputRef.value).lineHeight);
      textHeightRef.value.style.width = inputRef.value.clientWidth + "px"; // 设定宽度和 textarea 相同
      const lines = Math.floor(textHeightRef.value.clientHeight / lineHeight);
      inputRef.value.scrollTo(0, inputRef.value.scrollHeight);
      if (prompt.value.length < 10) {
        row.value = 1;
      } else if (lines <= 7) {
        row.value = lines;
      } else {
        row.value = 7;
      }

      // 输入回车自动提交
      if (e.keyCode === 13) {
        if (e.ctrlKey) {
          // Ctrl + Enter 换行
          prompt.value += "\n";
          return;
        }
        e.preventDefault();
        sendMessage();
      }
    };

    // 自动填充 prompt
    const autofillPrompt = text => {
      prompt.value = text;
      inputRef.value.focus();
      sendMessage();
    };
    // 发送消息
    const sendMessage = function () {
      if (!isLogin.value) {
        console.log("未登录");
        store.setShowLoginDialog(true);
        return;
      }
      if (store.socket.conn.readyState !== WebSocket.OPEN) {
        ElMessage.warning("连接断开，正在重连...");
        return;
      }
      if (canSend.value === false) {
        ElMessage.warning("AI 正在作答中，请稍后...");
        return;
      }
      if (prompt.value.trim().length === 0 || canSend.value === false) {
        showMessageError("请输入要发送的消息！");
        return false;
      }
      // 如果携带了文件，则串上文件地址
      let content = prompt.value;
      if (files.value.length === 1) {
        content += files.value.map(file => file.url).join(" ");
      } else if (files.value.length > 1) {
        showMessageError("当前只支持上传一个文件！");
        return false;
      }
      // 追加消息
      chatData.value.push({
        type: "prompt",
        id: randString(32),
        icon: loginUser.value.avatar,
        content: content,
        model: getModelValue(modelID.value),
        created_at: new Date().getTime() / 1000
      });
      nextTick(() => {
        document.getElementById("chat-box").scrollTo(0, document.getElementById("chat-box").scrollHeight);
      });
      showHello.value = false;
      disableInput(false);
      store.socket.conn.send(JSON.stringify({
        channel: "chat",
        type: "text",
        body: {
          role_id: roleId.value,
          model_id: modelID.value,
          chat_id: chatId.value,
          content: content,
          tools: toolSelected.value,
          stream: stream.value
        }
      }));
      tmpChatTitle.value = content;
      prompt.value = "";
      files.value = [];
      row.value = 1;
      return true;
    };
    const clearAllChats = function () {
      ElMessageBox.confirm("清除所有对话?此操作不可撤销！", "警告", {
        confirmButtonText: "删除对话",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        showClose: true,
        closeOnClickModal: false,
        center: false
      }).then(() => {
        httpGet("/chat/clear").then(() => {
          ElMessage.success("操作成功！");
          chatData.value = [];
          chatList.value = [];
          newChat();
        }).catch(e => {
          ElMessage.error("操作失败：" + e.message);
        });
      }).catch(() => {});
    };
    const loadChatHistory = function (chatId) {
      chatData.value = [];
      loading.value = true;
      httpGet("/chat/history?chat_id=" + chatId).then(res => {
        loading.value = false;
        const data = res.data;
        if ((!data || data.length === 0) && chatData.value.length === 0) {
          // 加载打招呼信息
          const _role = getRoleById(roleId.value);
          chatData.value.push({
            chat_id: chatId,
            role_id: roleId.value,
            type: "reply",
            id: randString(32),
            icon: _role["icon"],
            content: _role["hello_msg"]
          });
          return;
        }
        showHello.value = false;
        for (let i = 0; i < data.length; i++) {
          if (data[i].type === "reply" && i > 0) {
            data[i].prompt = data[i - 1].content;
          }
          chatData.value.push(data[i]);
        }
        nextTick(() => {
          document.getElementById("chat-box").scrollTo(0, document.getElementById("chat-box").scrollHeight);
        });
      }).catch(e => {
        // TODO: 显示重新加载按钮
        ElMessage.error("加载聊天记录失败：" + e.message);
      });
    };
    const stopGenerate = function () {
      showStopGenerate.value = false;
      httpGet("/chat/stop?session_id=" + getClientId()).then(() => {
        enableInput();
      });
    };

    // 重新生成
    const reGenerate = function (prompt) {
      disableInput(false);
      const text = "重新回答下述问题：" + prompt;
      // 追加消息
      chatData.value.push({
        type: "prompt",
        id: randString(32),
        icon: loginUser.value.avatar,
        content: text
      });
      store.socket.conn.send(JSON.stringify({
        channel: "chat",
        type: "text",
        body: {
          role_id: roleId.value,
          model_id: modelID.value,
          chat_id: chatId.value,
          content: text,
          tools: toolSelected.value,
          stream: stream.value
        }
      }));
    };
    const chatName = ref("");
    // 搜索会话
    const searchChat = function (e) {
      if (chatName.value === "") {
        chatList.value = allChats.value;
        return;
      }
      if (e.keyCode === 13) {
        const items = [];
        for (let i = 0; i < allChats.value.length; i++) {
          if (allChats.value[i].title.toLowerCase().indexOf(chatName.value.toLowerCase()) !== -1) {
            items.push(allChats.value[i]);
          }
        }
        chatList.value = items;
      }
    };

    // 导出会话
    const shareChat = chat => {
      if (!chat.chat_id) {
        return ElMessage.error("请先选中一个会话");
      }
      const url = location.protocol + "//" + location.host + "/chat/export?chat_id=" + chat.chat_id;
      window.open(url, "_blank");
    };
    const getModelValue = model_id => {
      for (let i = 0; i < models.value.length; i++) {
        if (models.value[i].id === model_id) {
          return models.value[i].value;
        }
      }
      return "";
    };
    const notShow = () => {
      localStorage.setItem(noticeKey.value, notice.value);
      showNotice.value = false;
    };
    const files = ref([]);
    // 插入文件
    const insertFile = file => {
      files.value.push(file);
    };
    const removeFile = file => {
      files.value = removeArrayItem(files.value, file, (v1, v2) => v1.url === v2.url);
    };

    // 实时语音对话
    const showConversationDialog = ref(false);
    // const conversationRef = ref(null);
    // const dialogHeight = ref(window.innerHeight - 75);
    const frameLoaded = ref(false);
    const realtimeChat = () => {
      if (!isLogin.value) {
        store.setShowLoginDialog(true);
        return;
      }
      showLoading("正在连接...");
      httpPost("/realtime/voice").then(res => {
        voiceChatUrl.value = res.data;
        showConversationDialog.value = true;
        closeLoading();
      }).catch(e => {
        showMessageError("连接失败：" + e.message);
        closeLoading();
      });
    };

    // const hangUp = () => {
    //   showConversationDialog.value = false;
    //   conversationRef.value.hangUp();
    // };

    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_aside, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
            onClick: _newChat,
            type: "primary",
            class: "newChat"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              style: {
                "margin-right": "5px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(Plus))]),
              _: 1
            }), _cache[14] || (_cache[14] = _createTextVNode(" 新建对话 "))]),
            _: 1
          }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
            modelValue: chatName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => chatName.value = $event),
            placeholder: "搜索会话",
            onKeyup: _cache[1] || (_cache[1] = $event => searchChat($event)),
            style: {},
            class: "search-input"
          }, {
            prefix: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "el-input__icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(Search))]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createVNode(_component_el_scrollbar, {
            height: chatBoxHeight.value
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatList.value, chat => {
              return _openBlock(), _createBlock(_component_el_row, {
                key: chat.chat_id
              }, {
                default: _withCtx(() => [_createElementVNode("div", {
                  class: _normalizeClass(chat.chat_id === chatId.value ? 'chat-list-item active' : 'chat-list-item'),
                  onClick: $event => loadChat(chat)
                }, [_createVNode(_component_el_image, {
                  src: chat.icon,
                  class: "avatar"
                }, null, 8, ["src"]), chat.edit ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createVNode(_component_el_input, {
                  modelValue: tmpChatTitle.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => tmpChatTitle.value = $event),
                  size: "small",
                  onKeydown: $event => titleKeydown($event, chat),
                  id: 'chat-' + chat.chat_id,
                  onBlur: $event => editConfirm(chat),
                  onClick: _cache[3] || (_cache[3] = $event => stopPropagation($event)),
                  placeholder: "请输入标题"
                }, null, 8, ["modelValue", "onKeydown", "id", "onBlur"])])) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(chat.title), 1)), _createElementVNode("span", _hoisted_8, [_createVNode(_component_el_dropdown, {
                  trigger: "click"
                }, {
                  dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                      icon: _unref(Edit),
                      onClick: $event => editChatTitle(chat)
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("重命名")])),
                      _: 2
                    }, 1032, ["icon", "onClick"]), _createVNode(_component_el_dropdown_item, {
                      icon: _unref(Delete),
                      style: {
                        "--el-text-color-regular": "var(--el-color-danger)",
                        "--el-dropdown-menuItem-hover-fill": "#f8e1de",
                        "--el-dropdown-menuItem-hover-color": "var(--el-color-danger)"
                      },
                      onClick: $event => removeChat(chat)
                    }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("删除")])),
                      _: 2
                    }, 1032, ["icon", "onClick"]), _createVNode(_component_el_dropdown_item, {
                      icon: _unref(Share),
                      onClick: $event => shareChat(chat)
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("分享")])),
                      _: 2
                    }, 1032, ["icon", "onClick"])]),
                    _: 2
                  }, 1024)]),
                  default: _withCtx(() => [_createElementVNode("span", {
                    class: "el-dropdown-link",
                    onClick: _cache[4] || (_cache[4] = $event => stopPropagation($event))
                  }, [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_unref(More))]),
                    _: 1
                  })])]),
                  _: 2
                }, 1024)])], 10, _hoisted_5)]),
                _: 2
              }, 1024);
            }), 128))])]),
            _: 1
          }, 8, ["height"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: clearAllChats
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [_createElementVNode("i", {
              class: "iconfont icon-clear"
            }, null, -1), _createTextVNode(" 清除所有对话 ")])),
            _: 1
          })])]),
          _: 1
        }), _withDirectives((_openBlock(), _createBlock(_component_el_main, {
          "element-loading-background": "rgba(122, 122, 122, 0.3)"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_select, {
            modelValue: roleId.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => roleId.value = $event),
            filterable: "",
            placeholder: "角色",
            onChange: _newChat,
            class: "role-select",
            style: {
              "width": "150px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_image, {
                  src: item.icon
                }, null, 8, ["src"]), _createElementVNode("span", null, _toDisplayString(item.name), 1)])]),
                _: 2
              }, 1032, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: modelID.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => modelID.value = $event),
            filterable: "",
            placeholder: "模型",
            onChange: _newChat,
            disabled: disableModel.value,
            style: {
              "width": "150px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(models.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, {
                default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createVNode(_component_el_tag, {
                  style: {
                    "margin-left": "5px",
                    "position": "relative",
                    "top": "-2px"
                  },
                  type: "info",
                  size: "small"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.power) + "算力 ", 1)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "disabled"]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_dropdown, {
            "hide-on-click": false,
            trigger: "click"
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
              class: "tools-dropdown"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                modelValue: toolSelected.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => toolSelected.value = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tools.value, item => {
                  return _openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: item.id
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                      value: item.id,
                      label: item.label
                    }, null, 8, ["value", "label"]), _createVNode(_component_el_tooltip, {
                      content: item.description,
                      placement: "right"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                        _: 1
                      })]),
                      _: 2
                    }, 1032, ["content"])]),
                    _: 2
                  }, 1024);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            default: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("span", {
              class: "setting"
            }, [_createElementVNode("i", {
              class: "iconfont icon-plugin"
            })], -1))]),
            _: 1
          }), _createElementVNode("span", {
            class: "setting",
            onClick: _cache[8] || (_cache[8] = $event => showChatSetting.value = true)
          }, _cache[20] || (_cache[20] = [_createElementVNode("i", {
            class: "iconfont icon-config"
          }, null, -1)]))])]), _createElementVNode("div", null, [_createElementVNode("div", {
            id: "container",
            style: _normalizeStyle({
              height: mainWinHeight.value + 'px'
            })
          }, [_createElementVNode("div", {
            class: "chat-box",
            id: "chat-box",
            style: _normalizeStyle({
              height: chatBoxHeight.value + 'px'
            })
          }, [showHello.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(Welcome, {
            onSend: autofillPrompt
          })])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(chatData.value, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.id
            }, [item.type === 'prompt' ? (_openBlock(), _createBlock(ChatPrompt, {
              key: 0,
              data: item,
              "list-style": listStyle.value
            }, null, 8, ["data", "list-style"])) : item.type === 'reply' ? (_openBlock(), _createBlock(ChatReply, {
              key: 1,
              data: item,
              onRegen: reGenerate,
              "read-only": false,
              "list-style": listStyle.value
            }, null, 8, ["data", "list-style"])) : _createCommentVNode("", true)]);
          }), 128)), _createVNode(BackTop, {
            right: 30,
            bottom: 155
          })], 4), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
            ref_key: "textHeightRef",
            ref: textHeightRef,
            class: "hide-div"
          }, _toDisplayString(prompt.value), 513), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [files.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(FileList, {
            files: files.value,
            onRemoveFile: removeFile
          }, null, 8, ["files"])])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("textarea", {
            ref_key: "inputRef",
            ref: inputRef,
            class: "prompt-input",
            rows: row.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => prompt.value = $event),
            onKeydown: onInput,
            onInput: onInput,
            placeholder: "按 Enter 键发送消息，使用 Ctrl + Enter 换行",
            autofocus: ""
          }, "                        ", 40, _hoisted_21), [[_vModelText, prompt.value]])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("span", {
            class: "tool-item-btn",
            onClick: realtimeChat
          }, [_createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: '实时语音对话，每次消耗' + config.value.advance_voice_power + '算力'
          }, {
            default: _withCtx(() => _cache[21] || (_cache[21] = [_createElementVNode("i", {
              class: "iconfont icon-mic-bold"
            }, null, -1)])),
            _: 1
          }, 8, ["content"])]), _createElementVNode("span", _hoisted_24, [_createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "上传附件"
          }, {
            default: _withCtx(() => [_createVNode(FileSelect, {
              "user-id": loginUser.value?.id,
              onSelected: insertFile
            }, null, 8, ["user-id"])]),
            _: 1
          })])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, [showStopGenerate.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "info",
            onClick: stopGenerate,
            plain: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(VideoPause))]),
              _: 1
            })]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: sendMessage,
            style: {
              "color": "#754ff6"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: "发送"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Promotion))]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }))])])])])])])])], 4)])])]),
          _: 1
        })), [[_directive_loading, loading.value]])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: showNotice.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => showNotice.value = $event),
        "show-close": true,
        class: "notice-dialog",
        title: "网站公告"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_29, [_createVNode(_component_el_button, {
          onClick: notShow,
          type: "primary"
        }, {
          default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("我知道了，不再显示")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", {
          innerHTML: notice.value
        }, null, 8, _hoisted_28)])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(ChatSetting, {
        show: showChatSetting.value,
        onHide: _cache[11] || (_cache[11] = $event => showChatSetting.value = false)
      }, null, 8, ["show"]), _createVNode(_component_el_dialog, {
        modelValue: showConversationDialog.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => showConversationDialog.value = $event),
        title: "实时语音通话",
        fullscreen: true
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createElementVNode("iframe", {
          style: {
            "width": "100%",
            "height": "calc(100vh - 100px)",
            "border": "none"
          },
          src: voiceChatUrl.value,
          onLoad: _cache[12] || (_cache[12] = $event => frameLoaded.value = true),
          allow: "microphone *;camera *;"
        }, null, 40, _hoisted_30)])), [[_directive_loading, !frameLoaded.value]])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};